var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ChatColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.3693114%",
    x2: "99.999575%",
    y2: "27.7870935%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-23.4%",
    width: "137.3%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "47.8694139%",
    x2: "93.8547498%",
    y2: "51.4203949%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.1096191,2.48608398 C90.8480225,-0.828674316 100.151978,-0.828704834 105.890381,2.48605347 L171.696167,40.4981079 C174.785645,42.2827148 176.211792,44.6642761 175.974609,47 L176,47 L176,82 L175.974609,82 C175.77124,84.0027161 174.345093,85.9717407 171.696167,87.5018921 L105.890381,125.513947 C100.151978,128.828705 90.8480225,128.828705 85.1096191,125.513947 L19.303833,87.5018921 C16.6549072,85.9717407 15.2287598,84.0027161 15.0253906,82 L15,82 L15,47 L15.0253906,47 C14.788208,44.6642761 16.2143555,42.2827148 19.303833,40.4981079 L85.1096191,2.48608398 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.6%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "46.7213098%",
    x2: "93.8547498%",
    y2: "52.1857998%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.699997,39.9327412 C133.699997,39.1327412 133.199998,38.232742 132.099998,37.6327419 L99.5999985,18.9327416 C97.3999984,17.7327415 94,17.7327415 91.7999992,18.9327416 L61,36.7327423 L61,71.7327423 L74.6000004,72.63274 C75.6000004,72.73274 76.5,72.9327408 77.1000004,73.3327408 L104,88.8327446 C106.2,90.0327415 109.599999,90.0327415 111.799999,88.8327446 L132,77.13274 C133.1,76.5327415 133.599998,75.7327408 133.599998,74.8327408 L133.699997,39.9327412 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.4456378%",
    x2: "93.8547498%",
    y2: "51.0362445%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.3595951,65.4317799 C60.2595951,67.5317798 61.6595953,69.7317814 64.4595952,71.3317814 L88.259594,85.0317841 L90.4595947,95.9317818 C90.6595947,96.8317817 91.7595978,97.6317841 93.2595978,98.0317841 C94.8595978,98.3317841 96.5595955,98.1317818 97.6595955,97.4317818 L137.659599,74.3317814 C139.759599,73.1317813 140.759599,71.5317802 140.659599,70.0317802 L140.659599,55.8317814 C140.659599,54.2317814 139.459599,52.5317814 137.159599,51.3317814 L136.759598,51.1317816 C134.959598,50.2317816 132.259599,50.3317814 130.659599,51.3317814 C129.059599,52.3317814 129.259593,53.9317814 131.059593,54.8317814 L131.459595,55.0317812 C132.259595,55.4317812 132.259593,56.1317812 131.559593,56.5317812 L97.9595947,76.231781 L96.6595955,69.5317802 C96.5595955,68.9317802 96.1595947,68.4317802 95.4595947,68.0317802 L70.5595951,53.731782 C68.3595951,52.431782 68.3595955,50.3317816 70.6595955,49.1317816 L72.8595953,47.9317818 C74.5595953,47.0317818 74.6595951,45.4317814 73.0595951,44.4317814 C71.4595951,43.4317814 68.7595952,43.3317814 66.9595952,44.3317814 L64.8595953,45.4317814 C61.9595952,47.0317814 60.4595951,49.1317813 60.3595951,51.3317814 L60.3595951,65.4317799 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.8685074,18.7683144 C94.0208282,17.525671 97.5104218,17.525671 99.6627426,18.7683105 L132.055267,37.4701462 C134.207581,38.7127876 134.207581,40.7275047 132.055267,41.9701462 L111.791626,53.6693611 C109.639313,54.9120026 106.149712,54.9120026 103.997398,53.6693611 L77.1913719,38.192894 C76.507019,37.7977829 75.6112175,37.5480042 74.6497192,37.4842072 L61.0182953,36.5796928 Z M90.9742661,23.5611839 C89.3002396,24.5276814 89.3002396,26.0946865 90.9742661,27.0611839 L117.836258,42.5699615 C119.510284,43.5364609 122.224411,43.5364609 123.898438,42.5699615 C125.572456,41.6034622 125.572464,40.0364609 123.898438,39.0699615 L97.0364456,23.5611839 C95.3624191,22.5946846 92.6482925,22.5946846 90.9742661,23.5611839 Z M89.392601,27.9743576 C87.7185822,27.0078602 85.0044479,27.0078602 83.3304214,27.9743576 C81.6564026,28.9408569 81.6564026,30.5078602 83.3304214,31.4743576 L102.379776,42.4725037 C104.053795,43.439003 106.767929,43.439003 108.441956,42.4725037 C110.115974,41.5060081 110.115974,39.939003 108.441956,38.9725037 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.1%",
    y: "-4.1%",
    width: "104.1%",
    height: "108.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.5,0 C99.3971558,0 103.134697,0.894265175 105.890396,2.48606777 L171.696167,40.4980965 C174.451874,42.0898972 176,44.248848 176,46.5 C176,48.7511444 174.451874,50.9100914 171.696167,52.5018959 L105.890388,90.5139236 C103.134689,92.1057281 99.3971481,93 95.5,93 C91.6028519,93 87.8653183,92.1057358 85.1096191,90.5139313 L19.3038397,52.5018997 C16.5481381,50.9100952 15,48.7511482 15,46.5 C15,44.2488518 16.5481389,42.0899048 19.3038406,40.4981003 L85.1096191,2.48606849 C87.8653183,0.894265652 91.6028595,0 95.5,0 Z M66.9950066,44.3741531 L64.7747688,45.5592918 C58.9042397,48.6929092 58.723568,54.0161438 64.3769646,57.2801361 L88.1853409,71.0259094 L90.3763657,81.9202957 C90.565979,82.8631134 91.672821,83.6602631 93.2254639,83.9722214 C94.7780991,84.2841873 96.5029907,84.0559998 97.665451,83.3848495 L137.68615,60.2788849 C141.931854,57.8276291 141.715439,53.8165512 137.213722,51.5226097 L136.836861,51.330574 C135.061897,50.4261017 132.353027,50.523632 130.786438,51.5484123 C129.219849,52.5731888 129.388771,54.1371536 131.163742,55.041626 L131.540604,55.2336617 C132.335022,55.6384735 132.373215,56.3463135 131.62397,56.7788849 L97.8701477,76.2666626 L96.529274,69.5994797 C96.4178467,69.0454178 95.9855042,68.529335 95.3023682,68.1349258 L70.4391403,53.7801361 C68.226944,52.5029221 68.2976379,50.4199181 70.5948029,49.193718 L72.8150444,48.0085831 C74.5533638,47.0806885 74.6596909,45.5148888 73.0525322,44.5112686 C71.4453735,43.5076485 68.733326,43.4462624 66.9950066,44.3741531 Z M85.8063278,15.2683144 L48.6798935,36.70327 C47.5167961,37.3747864 47.1218147,38.3713417 47.663353,39.2680664 C48.2048912,40.1647911 49.587429,40.8035278 51.2215462,40.9119606 L72.1860275,42.3030586 L97.9352188,57.1693611 C103.435585,60.3449974 112.353439,60.3450012 117.853806,57.1693611 L138.117439,45.4701462 C143.617813,42.2945061 143.617813,37.1457825 138.117447,33.9701462 L105.724915,15.2683105 C100.224548,12.0926714 91.3066864,12.0926781 85.8063278,15.2683144 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "38.8873864%",
    x2: "99.999575%",
    y2: "41.0663303%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176,46.8000755 C175.9,49.0000756 174.299997,51.0000753 171.699997,52.5000753 L105.900002,90.5000763 C103.100002,92.1000763 99.4000001,93.0000763 95.5,93.0000763 C91.5999999,93.0000763 87.8999984,92.1000763 85.0999985,90.5000763 L19.3000002,52.5000753 C16.7000003,51.0000753 15.1,49.0000756 15,46.8000755 C15,46.8667422 15,46.9334089 15,47.0000755 L15,82.0000763 C15.2,84.0000763 16.6000001,86.0000763 19.3000002,87.5000763 L85.0999985,125.500072 C90.7999983,128.800076 100.100001,128.800076 105.900002,125.500072 L171.699997,87.5000763 C174.299997,86.0000763 175.8,84.0000763 176,82.0000763 L176,47.0000755 C176,46.9334089 176,46.8667422 176,46.8000755 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.0%",
    y: "-8.0%",
    width: "108.1%",
    height: "116.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -3,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.810000002 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ChatColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1096191,12.486084 C90.8480225,9.17132568 100.151978,9.17129517 105.890381,12.4860535 L171.696167,50.4981079 C174.785645,52.2827148 176.211792,54.6642761 175.974609,57 L176,57 L176,92 L175.974609,92 C175.77124,94.0027161 174.345093,95.9717407 171.696167,97.5018921 L105.890381,135.513947 C100.151978,138.828705 90.8480225,138.828705 85.1096191,135.513947 L19.303833,97.5018921 C16.6549072,95.9717407 15.2287598,94.0027161 15.0253906,92 L15,92 L15,57 L15.0253906,57 C14.788208,54.6642761 16.2143555,52.2827148 19.303833,50.4981079 L85.1096191,12.486084 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    opacity: 0.8,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Back",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#000000",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.200000003,
    fill: "#000000",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-13)",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Side",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-16)",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-18)",
    xlinkHref: "#path-17"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatColor);
export default __webpack_public_path__ + "static/media/ChatColor.ea1c0e030da1fd102953c89bb3b60720.svg";
export { ForwardRef as ReactComponent };